// src/components/FocusLoader.jsx
import React from 'react';
import './FocusLoader.css';

const FocusLoader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <div className="mind-center">
          <div className="inner-circle"></div>
          <div className="pulse-ring pulse-1"></div>
          <div className="pulse-ring pulse-2"></div>
          <div className="pulse-ring pulse-3"></div>
        </div>
        
        <div className="growth-elements">
          <div className="growth-path">
            <div className="growth-node node-1"></div>
            <div className="growth-node node-2"></div>
            <div className="growth-node node-3"></div>
          </div>
        </div>
        
        <div className="loader-text">
          <span className="breath-text">Inspire...</span>
          <span className="breath-text">Expire...</span>
          <span className="focus-text">Conectando com seu potencial interior</span>
        </div>
      </div>
    </div>
  );
};

export default FocusLoader;